import styled from "styled-components";
import IntlTelInput from "react-phone-input-2";

const InputPhone = styled(IntlTelInput)`
  height: 44px;
  input:focus {
    border: 2px solid #2d5bff !important;
  }
  input:disabled {
    background: rgb(242, 244, 248);
    color: rgba(0, 0, 0, 0.38);
  }
`;

export const PhoneInput = ({
  disabled,
  value,
  onChange,
  isError,
}: {
  disabled?: boolean;
  value?: string;
  onChange: Function;
  isError?: boolean;
}) => {
  return (
    <InputPhone
      disabled={disabled}
      dropdownStyle={{ borderRadius: 8 }}
      placeholder="+55 (00) 00000-0000"
      buttonStyle={{
        border: "none",
        margin: 6,
        backgroundColor: "transparent",
      }}
      value={value}
      onChange={(_, __, ___, val) => {
        onChange(val);
      }}
      inputStyle={{
        borderWidth: 1,
        borderRadius: 8,
        paddingTop: 3,
        width: "100%",
        height: 44,
        borderColor: isError ? "red" : "#C4C4C4",
      }}
      country="br"
    />
  );
};
